import axiosInstance from "../../../../../api/axios";

export const getUpperAndLowerLimit = async ( measurementId: number): Promise<any | null> => {
    try {
        const response = await axiosInstance.get(`/measurement-result/getSingleSampleControlChartData/${measurementId}`);
        console.log("success", response.data);
        return response.data;
    } catch (error) {
        console.error("error", error);
        return null;
    }
};